// src/services/notificationApi.js
// Servicio para las notificaciones WhatsApp asociadas a cambios de estado en citas de grooming

import { dotoniwoofApi } from '../api/dotoniwooApi';

const NOTIFICATION_BASE = '/notification.php';

/**
 * Lista notificaciones con filtros y paginación
 * @param {Object} params - Parámetros de consulta
 * @param {string} [params.status] - PENDIENTE | ENVIADO | FALLIDO | ENVIANDO
 * @param {string} [params.from] - Fecha desde YYYY-MM-DD (created_at)
 * @param {string} [params.to] - Fecha hasta YYYY-MM-DD (created_at)
 * @param {number} [params.limit] - Registros por página (1–500, defecto 50)
 * @param {number} [params.offset] - Desplazamiento para paginación
 * @returns {Promise<Object>} { ok, status, data }
 */
export const getNotificationList = async (params = {}) => {
  try {
    const searchParams = new URLSearchParams();
    if (params.status) searchParams.append('status', params.status);
    if (params.from) searchParams.append('from', params.from);
    if (params.to) searchParams.append('to', params.to);
    searchParams.append('limit', params.limit != null ? params.limit : 50);
    searchParams.append('offset', params.offset != null ? params.offset : 0);

    const response = await dotoniwoofApi.get(`${NOTIFICATION_BASE}/list?${searchParams.toString()}`);

    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al listar notificaciones:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' },
    };
  }
};

/**
 * Obtiene el detalle de una notificación por id_not_queue (incluye últimos logs)
 * @param {number} id - id_not_queue
 * @returns {Promise<Object>} { ok, status, data }
 */
export const getNotificationById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`${NOTIFICATION_BASE}/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener notificación:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' },
    };
  }
};

/**
 * Actualiza el estado de una notificación (p. ej. para volver a enviarla)
 * @param {number} id - id_not_queue
 * @param {Object} body - id_status (número) o status_name ("PENDIENTE"|"ENVIADO"|"FALLIDO"|"ENVIANDO"), reset_attempts (opcional)
 * @returns {Promise<Object>} { ok, status, data }
 */
export const patchNotification = async (id, body) => {
  try {
    const response = await dotoniwoofApi.patch(`${NOTIFICATION_BASE}/${id}`, body);
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al actualizar notificación:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' },
    };
  }
};

/**
 * Reintento rápido para notificaciones fallidas: las deja en PENDIENTE, intentos en 0 y sin error.
 * @param {number} id - id_not_queue
 * @returns {Promise<Object>} { ok, status, data }
 */
export const retryNotification = async (id) => {
  try {
    const response = await dotoniwoofApi.post(`${NOTIFICATION_BASE}/retry`, { id });
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al reintentar notificación:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' },
    };
  }
};
